import React from 'react';

function Full({ children }) {
    return (
        <>
            {children}
        </>
    );
}

export default Full;
